module.exports = __webpack_public_path__ + "img/growth-dark.d2fb8d2c.svg";